import { Error500, SEO } from 'components/common'

export const Head = () => <SEO title="Internal Server Error" />

const InternalErrorPage = (): JSX.Element => {
  return (
    <>
      <Error500 />
    </>
  )
}

export default InternalErrorPage
